import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Table,
  Alert,
  Modal,
} from "react-bootstrap";
import * as XLSX from "xlsx";
import axios from "axios";
import { format } from "date-fns";

const ScheduleUpdate = () => {
  const [schedules, setSchedules] = useState([]);
  const [applyDate, setApplyDate] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadPendingSchedules();
  }, []);

  const loadPendingSchedules = async () => {
    try {
      const response = await axios.get(
        "https://doticom.vn:3000/api/price-schedule/pending",
      );
      if (response.data.success) {
        setSchedules(response.data.data);
      }
    } catch (error) {
      console.error("Lỗi tải lịch giá:", error);
      setMessage({ type: "danger", text: "Không thể tải danh sách lịch giá" });
    }
  };

  const downloadTemplate = () => {
    const template = [
      {
        "Mã SP": "SP001",
        "Giá Mua": 30000,
        "Giá Thường": 50000,
        "Giá Nhân Viên": 45000,
        "Giá Grab/Foody": 40000,
      },
      {
        "Mã SP": "SP002",
        "Giá Mua": 30000,
        "Giá Thường": 60000,
        "Giá Nhân Viên": 55000,
        "Giá Grab/Foody": 50000,
      },
    ];

    const ws = XLSX.utils.json_to_sheet(template);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");

    ws["!cols"] = [
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 18 },
      { wch: 18 },
    ];

    XLSX.writeFile(wb, "template_lich_gia.xlsx");
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const workbook = XLSX.read(event.target.result, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(worksheet);

        const formattedProducts = data.map((row) => ({
          MaSP: row["Mã SP"] || row["MaSP"] || "",
          GiaMua: parseFloat(row["Giá Mua"] || row["GiaMua"] || 0),
          DonGia: parseFloat(
            row["Giá Thường"] || row["Đơn Giá"] || row["DonGia"] || 0,
          ),
          DonGia1: parseFloat(
            row["Giá Nhân Viên"] ||
              row["Giá nhân viên"] ||
              row["Đơn Giá 1"] ||
              row["DonGia1"] ||
              0,
          ),
          DonGia2: parseFloat(
            row["Giá Grab/Foody"] ||
              row["Giá Grab"] ||
              row["Giá Foody"] ||
              row["Đơn Giá 2"] ||
              row["DonGia2"] ||
              0,
          ),
        }));

        setProducts(formattedProducts);
        setMessage({
          type: "success",
          text: `Đã tải ${formattedProducts.length} sản phẩm từ file Excel`,
        });
      } catch (error) {
        console.error("Lỗi đọc file:", error);
        setMessage({
          type: "danger",
          text: "Lỗi đọc file Excel. Vui lòng kiểm tra định dạng file.",
        });
      }
    };
    reader.readAsBinaryString(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!applyDate) {
      setMessage({ type: "warning", text: "Vui lòng chọn ngày áp dụng" });
      return;
    }

    if (products.length === 0) {
      setMessage({
        type: "warning",
        text: "Vui lòng import danh sách sản phẩm",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://doticom.vn:3000/api/price-schedule",
        {
          products,
          applyDate,
        },
      );

      if (response.data.success) {
        setMessage({ type: "success", text: response.data.message });
        setProducts([]);
        setApplyDate("");
        loadPendingSchedules();
        document.getElementById("fileInput").value = "";
      }
    } catch (error) {
      console.error("Lỗi tạo lịch:", error);
      setMessage({
        type: "danger",
        text: error.response?.data?.error || "Không thể tạo lịch cập nhật giá",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleApplyNow = async (scheduleIds) => {
    if (!window.confirm("Bạn có chắc muốn áp dụng giá ngay bây giờ?")) return;

    setLoading(true);
    try {
      const response = await axios.post(
        "https://doticom.vn:3000/api/price-schedule/apply-now",
        {
          scheduleIds,
        },
      );

      if (response.data.success) {
        setMessage({ type: "success", text: response.data.message });
        loadPendingSchedules();
      }
    } catch (error) {
      console.error("Lỗi áp dụng giá:", error);
      setMessage({ type: "danger", text: "Không thể áp dụng giá" });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bạn có chắc muốn hủy lịch này?")) return;

    setLoading(true);
    try {
      const response = await axios.delete(
        `https://doticom.vn:3000/api/price-schedule/${id}`,
      );
      if (response.data.success) {
        setMessage({ type: "success", text: response.data.message });
        loadPendingSchedules();
      }
    } catch (error) {
      console.error("Lỗi xóa lịch:", error);
      setMessage({ type: "danger", text: "Không thể hủy lịch" });
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(value);
  };

  const groupedSchedules = schedules.reduce((acc, schedule) => {
    const date = format(new Date(schedule.ApplyDate), "dd/MM/yyyy");
    if (!acc[date]) acc[date] = [];
    acc[date].push(schedule);
    return acc;
  }, {});

  const modernTheme = {
    pageBackground: {
      background: "#f0f4f8",
      minHeight: "100vh",
      position: "relative",
    },
    titleStyle: {
      color: "#1a202c",
      fontWeight: "600",
      position: "relative",
      paddingBottom: "15px",
      marginBottom: "20px",
    },
    cardStyle: {
      border: "1px solid #e2e8f0",
      borderRadius: "12px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
      background: "#ffffff",
      overflow: "hidden",
    },
    cardHeader: {
      background: "#273becff",
      color: "#ffffffff",
      borderBottom: "none",
      fontWeight: "600",
      padding: "16px 20px",
    },
    primaryButton: {
      background: "#273becff",
      border: "none",
      borderRadius: "8px",
      fontWeight: "500",
      color: "#fdfdfdff",
      boxShadow: "0 2px 6px rgba(135, 206, 235, 0.3)",
      transition: "all 0.3s ease",
      padding: "10px 20px",
    },
    successButton: {
      background: "#273becff",
      border: "none",
      color: "#ffffff",
      borderRadius: "8px",
      fontWeight: "500",
      boxShadow: "0 2px 6px rgba(93, 173, 226, 0.3)",
      padding: "8px 16px",
    },
    outlineButton: {
      border: "2px solid #273becff",
      color: "#273becff",
      borderRadius: "8px",
      fontWeight: "500",
      background: "transparent",
      transition: "all 0.3s ease",
      padding: "8px 16px",
    },
    tableStyle: {
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
    },
    tableHeader: {
      background: "#273becff",
      color: "#1a202c",
      fontWeight: "600",
      borderBottom: "none",
    },
    dateSection: {
      background: "#f8f9fa",
      padding: "16px",
      borderRadius: "8px",
      border: "1px solid #e2e8f0",
      marginBottom: "15px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
    },
    emptyState: {
      color: "#718096",
      textAlign: "center",
      padding: "60px 20px",
      background: "#f8f9fa",
      borderRadius: "12px",
      border: "2px dashed #cbd5e0",
    },
    alertStyle: {
      borderRadius: "8px",
      border: "none",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
    },
  };

  return (
    <>
      <style>
        {`
          .modern-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 10px rgba(135, 206, 235, 0.4) !important;
            background: #1937e6ff !important;
          }

          .modern-outline-button:hover {
            background: #87ceeb !important;
            color: #1a202c !important;
            border-color: #87ceeb !important;
          }

          .table-striped tbody tr:nth-of-type(odd) {
            background-color: #f8f9fa;
          }

          .table-hover tbody tr:hover {
            background-color: #e6f4f9;
          }

          .form-control:focus {
            border-color: #87ceeb;
            box-shadow: 0 0 0 0.2rem rgba(135, 206, 235, 0.25);
          }

          .form-label {
            color: "#2d3748";
            font-weight: 500;
            margin-bottom: 8px;
          }

          .card {
            transition: all 0.3s ease;
          }
        `}
      </style>

      <div style={modernTheme.pageBackground}>
        <Container
          fluid
          className="py-4"
          style={{ position: "relative", zIndex: 1 }}
        >
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <h2 style={modernTheme.titleStyle}>Lịch Cập Nhật Giá Sản Phẩm</h2>
            <p
              style={{
                color: "#718096",
                fontSize: "0.95rem",
                marginTop: "8px",
              }}
            >
              Quản lý và lên lịch cập nhật giá tự động
            </p>
          </div>

          {message.text && (
            <Alert
              variant={message.type}
              onClose={() => setMessage({ type: "", text: "" })}
              dismissible
              style={modernTheme.alertStyle}
            >
              {message.text}
            </Alert>
          )}

          <Row>
            <Col lg={5}>
              <Card className="mb-4" style={modernTheme.cardStyle}>
                <Card.Header style={modernTheme.cardHeader}>
                  <h5 className="mb-0">Tạo Lịch Mới</h5>
                </Card.Header>
                <Card.Body style={{ padding: "25px" }}>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Ngày Áp Dụng</Form.Label>
                      <Form.Control
                        type="datetime-local"
                        value={applyDate}
                        onChange={(e) => setApplyDate(e.target.value)}
                        required
                        style={{
                          borderRadius: "8px",
                          border: "1px solid #cbd5e0",
                        }}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Import File Excel</Form.Label>
                      <Form.Control
                        id="fileInput"
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleFileUpload}
                        style={{
                          borderRadius: "8px",
                          border: "1px solid #cbd5e0",
                        }}
                      />
                      <Form.Text
                        style={{ color: "#718096", fontWeight: "400" }}
                      >
                        Chọn file Excel chứa danh sách giá mới
                      </Form.Text>
                    </Form.Group>

                    <div className="d-flex gap-2 mb-3 flex-wrap">
                      <Button
                        style={modernTheme.outlineButton}
                        className="modern-outline-button"
                        onClick={downloadTemplate}
                        size="sm"
                      >
                        <i className="bi bi-download"></i> Tải File Mẫu
                      </Button>
                      {products.length > 0 && (
                        <Button
                          style={modernTheme.outlineButton}
                          className="modern-outline-button"
                          onClick={() => setShowModal(true)}
                          size="sm"
                        >
                          <i className="bi bi-eye"></i> Xem {products.length} sản
                          phẩm
                        </Button>
                      )}
                    </div>

                    <Button
                      style={modernTheme.primaryButton}
                      className="modern-button w-100"
                      type="submit"
                      disabled={loading || products.length === 0}
                    >
                      {loading ? "Đang xử lý..." : "Tạo Lịch Cập Nhật"}
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={7}>
              <Card style={modernTheme.cardStyle}>
                <Card.Header
                  style={{
                    ...modernTheme.cardHeader,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h5 className="mb-0">Lịch Giá Chờ Áp Dụng</h5>
                  <Button
                    style={{
                      background: "rgba(255,255,255,0.4)",
                      border: "1px solid rgba(255,255,255,0.6)",
                      color: "#1a202c",
                      borderRadius: "8px",
                      padding: "6px 12px",
                    }}
                    size="sm"
                    onClick={loadPendingSchedules}
                  >
                    <i className="bi bi-arrow-clockwise"></i> Làm mới
                  </Button>
                </Card.Header>
                <Card.Body
                  style={{
                    maxHeight: "600px",
                    overflowY: "auto",
                    padding: "20px",
                  }}
                >
                  {Object.keys(groupedSchedules).length === 0 ? (
                    <div style={modernTheme.emptyState}>
                      <div style={{ fontSize: "3rem", marginBottom: "20px" }}>
                        📋
                      </div>
                      <p style={{ fontSize: "1.1rem", fontWeight: "500" }}>
                        Không có lịch giá nào đang chờ
                      </p>
                      <p style={{ color: "#718096", marginTop: "10px" }}>
                        Hãy tạo lịch mới để bắt đầu!
                      </p>
                    </div>
                  ) : (
                    Object.entries(groupedSchedules).map(([date, items]) => (
                      <div key={date} style={modernTheme.dateSection}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6
                            style={{
                              color: "#2d3748",
                              marginBottom: 0,
                              fontWeight: "600",
                              fontSize: "1rem",
                            }}
                          >
                            📅 {date}
                          </h6>
                          <Button
                            style={modernTheme.successButton}
                            className="modern-button"
                            size="sm"
                            onClick={() =>
                              handleApplyNow(items.map((i) => i.ID))
                            }
                            disabled={loading}
                          >
                            <i className="bi bi-check-circle"></i> Áp dụng ngay
                          </Button>
                        </div>
                        <div style={modernTheme.tableStyle}>
                          <Table striped bordered hover size="sm" className="mb-0">
                            <thead>
                              <tr style={modernTheme.tableHeader}>
                                <th>Mã SP</th>
                                <th>Giá Mua</th>
                                <th>Giá Thường</th>
                                <th>Giá Nhân Viên</th>
                                <th>Giá Grab/Foody</th>
                                <th width="80">Thao tác</th>
                              </tr>
                            </thead>
                            <tbody>
                              {items.map((schedule) => (
                                <tr key={schedule.ID}>
                                  <td
                                    style={{
                                      fontWeight: "600",
                                      color: "#2d3748",
                                    }}
                                  >
                                    {schedule.MaSP}
                                  </td>
                                  <td style={{ color: "#4a5568" }}>
                                    {formatCurrency(schedule.GiaMua)}
                                  </td>
                                  <td style={{ color: "#4a5568" }}>
                                    {formatCurrency(schedule.DonGia)}
                                  </td>
                                  <td style={{ color: "#4a5568" }}>
                                    {formatCurrency(schedule.DonGia1)}
                                  </td>
                                  <td style={{ color: "#4a5568" }}>
                                    {formatCurrency(schedule.DonGia2)}
                                  </td>
                                  <td>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      className="d-flex align-items-center gap-1"
                                      onClick={() => handleDelete(schedule.ID)}
                                      disabled={loading}
                                      style={{
                                        borderRadius: "6px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      <i className="bi bi-trash"></i>
                                      Xóa
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    ))
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
            <Modal.Header closeButton style={modernTheme.cardHeader}>
              <Modal.Title>Danh Sách Sản Phẩm Import</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                background: "#ffffff",
              }}
            >
              <div style={modernTheme.tableStyle}>
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr style={modernTheme.tableHeader}>
                      <th>STT</th>
                      <th>Mã SP</th>
                      <th>Giá Mua</th>
                      <th>Giá Thường</th>
                      <th>Giá Nhân Viên</th>
                      <th>Giá Grab/Foody</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product, index) => (
                      <tr key={index}>
                        <td style={{ fontWeight: "600", color: "#2d3748" }}>
                          {index + 1}
                        </td>
                        <td style={{ fontWeight: "600", color: "#2d3748" }}>
                          {product.MaSP}
                        </td>
                        <td style={{ color: "#4a5568" }}>
                          {formatCurrency(product.GiaMua)}
                        </td>
                        <td style={{ color: "#4a5568" }}>
                          {formatCurrency(product.DonGia)}
                        </td>
                        <td style={{ color: "#4a5568" }}>
                          {formatCurrency(product.DonGia1)}
                        </td>
                        <td style={{ color: "#4a5568" }}>
                          {formatCurrency(product.DonGia2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Modal.Body>
            <Modal.Footer
              style={{
                background: "#f8f9fa",
                borderTop: "1px solid #e2e8f0",
              }}
            >
              <Button
                style={modernTheme.outlineButton}
                className="modern-outline-button"
                onClick={() => setShowModal(false)}
              >
                Đóng
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </div>
    </>
  );
};

export default ScheduleUpdate;